/*
 * @Author: zhengxiaowen
 * @Date: 2018-09-21 09:22:12
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-10-12 16:52:27
 */

import {nativeApi} from '../index'
export default {
  state: {
    demoScrollTop: 0,
    isLoading: false,
    direction: 'forward',
    completeDataStatus:false //默认表单数据变化false
  },
  getters: {

  },
  mutations: {
    updateDemoPosition (state, payload) {
      state.demoScrollTop = payload.top
    },
    updateLoadingStatus (state, payload) {
      state.isLoading = payload.isLoading
    },
    updateDirection (state, payload) {
      state.direction = payload.direction
    },
    updateCompleteDataStatus(state,payload){
      state.completeDataStatus = payload;
      // if(api.isMobile){
      //   window.postMessage(JSON.stringify({nativeType:'completeDataStatus',value:payload}));
      // }
      if(sessionStorage.isNative == true){
        nativeApi.nativeFN.completeDataStatus(payload)
      }
    }
  },
  actions: {
    updateDemoPosition ({commit}, top) {
      commit({type: 'updateDemoPosition', top: top})
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/store/VuxStore.js